module.exports = __webpack_public_path__ + "static/media/workflow.a67a61dc.png";